module.exports = __webpack_public_path__ + "static/media/close.7b310f40.svg";